import React from 'react';
import { LazySection } from './LazySection';
export function Garantia() {
  return <LazySection className="bg-cream-dark !py-[60px] md:!py-[80px]" data-id="element-167">
      <div className="container-custom" data-id="element-168">
        <div className="max-w-[720px] mx-auto bg-white border-2 border-gold rounded-[20px] p-8 md:px-10 md:py-11 text-center relative shadow-soft" data-id="element-169">
          <div className="inline-block bg-ink text-gold-light px-4 py-2 rounded-full text-[12px] font-semibold tracking-[0.15em] mb-4" data-id="element-170">
            🛡️ GARANTÍA 7 DÍAS · SIN PREGUNTAS
          </div>
          <h2 className="text-[clamp(24px,3.5vw,32px)] mb-4" data-id="element-171">
            Si no es para vos, te devolvemos el 100%.
          </h2>
          <p className="text-ink-soft text-[15px] leading-[1.6] mb-4" data-id="element-172">
            Hacés el primer módulo. Si en 7 días sentís que no es para vos,{' '}
            <strong data-id="element-173">te devolvemos todo</strong>. Sin formularios ni preguntas
            incómodas.
          </p>
          <div className="bg-cream-dark p-5 rounded-xl font-serif italic text-[16px] text-ink leading-[1.5] mb-4" data-id="element-174">
            El riesgo es cero.{' '}
            <strong className="not-italic font-medium" data-id="element-175">
              Lo único que perdés si no lo probás es otro año repitiendo lo
              mismo.
            </strong>
          </div>
        </div>
      </div>
    </LazySection>;
}